export function getSelectedRows(selectedIDs: any[], rows: any[], getIdFn: (row: any) => any) {
    const idset = new Set(selectedIDs);
    return rows.filter(row => idset.has(getIdFn(row)));
}